import { NotificationType } from '../notification/notification';

export enum GlobalErrorCode {
  ServerError = "SERVER_ERROR",
}

export enum FormInputErrorCode {
  InvalidToken = "INVALID_TOKEN",
  UniqueConstraint = "UNIQUE_CONSTRAINT",
  PasswordMismatch = "PASSWORD_MISMATCH",
  InvalidMeetingPointTitle = "INVALID_MEETING_POINT_TITLE",
  ValueTooLong = "VALUE_TOO_LONG",
}

export enum CustomErrorCode {
  LockedUserAccount = "LOCKED_USER_ACCOUNT",
}

export enum JourneyOfferErrorCode {
  OfferMissed = "OFFER_MISSED",
  OfferExpired = "OFFER_EXPIRED",
}

export enum FormErrorCode {
  NumberNotAllowedRange = "NUMBER_NOT_IN_ALLOWED_RANGE",
  InvalidJourneyStatus = "INVALID_JOURNEY_STATUS",
  BadCredentials = "BAD_CREDENTIALS",
  ExpiredToken = "EXPIRED_TOKEN",
  InvalidToken = "INVALID_TOKEN",
  HubTypeMissing = "HUB_TYPE_MISSING",
  HubGeoLocationMissing = "HUB_GEO_LOCATION_MISSING",
  HubCurrencyMissing = "HUB_CURRENCY_MISSING",
  HubMeasurementSystemMissing = "HUB_MEASUREMENT_SYSTEM_MISSING",
  HubTimeZoneMissing = "HUB_TIME_ZONE_MISSING",
  HubCountryCodeMissing = "HUB_COUNTRY_CODE_MISSING",
  HubManagerMissing = "HUB_MANAGER_MISSING",
  VatLevelMissing = "VAT_LEVEL_MISSING",
  CompliteJourneyNotAllowed = "COMPLETE_JOURNEY_NOT_ALLOWED_BEFORE_PICKUP",
  InvalidMaxCombinedBabyAndBoosterSeatsMaxValue = "INVALID_MAX_COMBINED_BABYANDBOOSTER_SEATS_MAX_VALUE",
  LockedUserAccount = "LOCKED_USER_ACCOUNT",
}

export type ErrorCode = GlobalErrorCode & FormInputErrorCode & CustomErrorCode & FormErrorCode & JourneyOfferErrorCode;

export const GLOBAL_ERROR = {
  [GlobalErrorCode.ServerError]: {
    title: 'Error',
    message: 'Internal server error',
    type: NotificationType.Danger,
  },
};

export const FIELD_ERROR = {
  [FormInputErrorCode.InvalidToken]: {
    message: 'The supplied token is incorrect.',
  },
  [FormInputErrorCode.UniqueConstraint]: {
    message: 'Email already exist.',
  },
  [FormInputErrorCode.PasswordMismatch]: {
    message: 'Password does not match your current one',
  },
  [FormInputErrorCode.InvalidMeetingPointTitle]: {
    message: 'longTitle',
  },
  [FormInputErrorCode.ValueTooLong]: {
    message: 'longDescription',
  },
};

export const FORM_ERROR = {
  [FormErrorCode.BadCredentials]: {
    message: 'This combination of username and password is incorrect.',
  },
  [FormErrorCode.InvalidToken]: {
    message: 'The password reset token is incorrect.',
  },
  [FormErrorCode.ExpiredToken]: {
    message: 'The password reset token has expired.',
  },
  [FormErrorCode.HubTypeMissing]: {
    message: 'Hub type is missing.',
  },
  [FormErrorCode.HubGeoLocationMissing]: {
    message: 'Hub geo location is missing.',
  },
  [FormErrorCode.HubCurrencyMissing]: {
    message: 'Hub currency is missing.',
  },
  [FormErrorCode.HubMeasurementSystemMissing]: {
    message: 'Hub measurement system is missing.',
  },
  [FormErrorCode.HubTimeZoneMissing]: {
    message: 'Hub time zone is missing.',
  },
  [FormErrorCode.HubCountryCodeMissing]: {
    message: 'Hub country code is missing.',
  },
  [FormErrorCode.HubManagerMissing]: {
    message: 'Hub manager is missing.',
  },
  [FormErrorCode.VatLevelMissing]: {
    message: 'VAT level is missing.',
  },
  [FormErrorCode.CompliteJourneyNotAllowed]: {
    message: 'The pickup date of this journey is in the future, not allowed to already mark as completed.',
  },
  [FormErrorCode.InvalidMaxCombinedBabyAndBoosterSeatsMaxValue]: {
    message: 'Number of baby and booster seats combined is more than max allowed value',
  },
  [FormErrorCode.LockedUserAccount]: {
    message: 'This user account is locked. Please wait 5 minutes and try again or contact the administrator',
  },
};
